import { Typography } from '@breetometer/components';
import { FiatIcon } from 'BreetAssets';
import { Dropdown } from 'BreetComponents';
import { capitalizeFirstLetter } from 'BreetHelpers';
import { useFundRequestContext } from 'BreetHooks';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';

import DropdownItemsFundingMethod from './DropdownItemsFundingMethod';

const FundingMethod = () => {
	const { fundingMethod, selectFundingMethod, selectedWallet } = useFundRequestContext();

	const fiatMeta = useAppSelector(selectFiatMeta);

	const fundingMethodItems = [
		{
			name: 'Crypto',
			value: 'Crypto',
			code: '',
			icon: '',
		},
		{
			name: `${capitalizeFirstLetter(fiatMeta.currencyShort)} Bank Transfer`,
			value: `${capitalizeFirstLetter(fiatMeta.currencyShort)} Bank Transfer`,
			code: '',
			icon: (
				<FiatIcon
					variant='round'
					currencyCode={fiatMeta.currency}
				/>
			),
		},
	];

	return (
		<div className='new-funding-method'>
			<Typography className='color-primary-100'>How do you want to fund your wallet?</Typography>
			<div className='new-drop-down-input fund-wallet-input'>
				<Dropdown.Modern
					items={fundingMethodItems.filter((item) => {
						if (selectedWallet?.value === 'USD') {
							return item.value === 'Crypto';
						}
						return true;
					})}
					label={fundingMethod ? '' : 'Select Funding Method'}
					id='select-funding-method-type'
					selectedItem={{ name: fundingMethod, code: '', value: fundingMethod, icon: '' }}
					handleItemSelect={selectFundingMethod}
					CustomItemOption={DropdownItemsFundingMethod}
				/>
			</div>
		</div>
	);
};

export default FundingMethod;
